import component from './paycell-card-add.component';
import routes from './paycell-card-add.routes';

export default angular
  .module('fizyweb.paycell.cardAdd', [])
  .component('fizyPaycellCardAdd', component)
  .config(routes).name;



// WEBPACK FOOTER //
// src/app/buy/paycell-card-add/paycell-card-add.module.ts